import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/solid';

export const DesktopSidebarToggle = ({ isOpen, setIsOpen, t }) => (
  <button
    className={`flex items-center hover:cursor-pointer ${isOpen ? 'self-end' : 'self-center justify-center'}`}
    onClick={() => setIsOpen(!isOpen)}
  >
    {isOpen && <span className={`text-pdwhite mr-4 font-semibold uppercase`}>{t('collapse')}</span>}
    <div className="bg-pdwhite inline-flex aspect-square h-8 w-8 items-center justify-center rounded-full font-black">
      {isOpen ? (
        <ArrowLeftIcon aria-hidden="true" className="center size-4 text-black" />
      ) : (
        <ArrowRightIcon aria-hidden="true" className="center size-4 text-black" />
      )}
    </div>
  </button>
);
